import CancelDropOffAppointmentModal from "@modules/purchase/components/offer/CancelDropOffAppointmentModal";
import useCancelDropOffAppointmentMutation from "@modules/purchase/hooks/useCancelDropOffAppointmentMutation";
import { Purchase } from "@modules/purchase/types/Purchase";
import { useRouter } from "next/router";

type Props = {
  purchase: Purchase;
  onClose?: (appointmentCancelled: boolean) => void;
};

const CustomerCancelDropOffAppointmentModal = ({
  purchase,
  onClose,
}: Props) => {
  const { locale } = useRouter();
  const { mutate } = useCancelDropOffAppointmentMutation();

  const handleOnCancel = () => {
    mutate(
      { dealId: purchase.id, locale },
      {
        onSuccess: () => {
          onClose?.(true);
        },
      }
    );
  };

  if (
    !purchase.dropOffDetails?.dropOffLocationAppointmentAt ||
    !purchase.dropOffDetails?.dropOffLocationName
  ) {
    return null;
  }

  return (
    <CancelDropOffAppointmentModal
      dropOffAppointmentAt={
        purchase.dropOffDetails.dropOffLocationAppointmentAt
      }
      dropOffLocationName={purchase.dropOffDetails.dropOffLocationName}
      onClose={() => onClose?.(false)}
      onCancel={handleOnCancel}
    />
  );
};

export default CustomerCancelDropOffAppointmentModal;
